module.exports = __webpack_public_path__ + "img/skh2.8bd250ab.jpg";